import { v4 as uuidv4 } from "uuid";
import CalculatorImg from "../images/calculatorPic.png";
import PasswordGeneratorImg from "../images/password_generator_pic.png";
import RatingComponentImg from "../images/rating_component_pic.png";
import TodoListImg from "../images/todolist_pic.png";
import EcomImg from "../images/ecom_pic_crop.png";
import AppointmentImg from "../images/appointment_pic_crop.png";
import SoulFeltImg from "../images/SoulFeltMusicDemo.png";
import PatientManagementImg from "../images/patientMangement.png";
import ContentSchedulerImg from "../images/contentScheduler.png";
import ShopifyEcomCustomAppImg from "../images/Shopify_custom_app_image.png";
import ShopifyThemeCustomizationImg from "../images/Shopify_theme_app.png";
import CinemaBookingImg from "../images/Cinema-app-image.png";

const projects = [
  {
    id: uuidv4(),
    name: "Ecommerce Shop",
    desc: "Full-featured ecommerce platform displaying musical instruments with shopping cart functionality and product management.",
    img: EcomImg,
    link: "https://marlos-ecommerce-shop-app-demo.netlify.app/",
    category: "Full-Stack",
    tech: ["React", "Redux", "MongoDB", "Node.js", "API"],
  },
  {
    id: uuidv4(),
    name: "Music streaming E-commerce Shop",
    desc: " This is a full-stack music streaming platform I built using React, Node.js, and MySQL.",
    img: SoulFeltImg,
    link: "https://soulfeltmusicdemo.netlify.app/",
    category: "Full-Stack",
    tech: ["React", "Express", "Sql", "Node.js", "API"],
  },
  {
    id: uuidv4(),
    name: "Content Scheduler",
    desc: "This is Content Scheduler a full‑stack content planning app that demonstrates scheduling UX, analytics, and production-ready patterns",
    img: ContentSchedulerImg,
    link: "https://content-scheduler-demo.netlify.app/calendar",
    category: "Full-Stack",
    tech: ["React", "Express", "node.js", "SQL", "Date Management"],
  },
  {
    id: uuidv4(),
    name: "Patient Management System",
    desc: "This is a full-stack web app built with React, Vite, Express, and Prisma. It’s designed to streamline patient care, appointment scheduling, and user management for clinics. I’ll walk you through the main features and the technical decisions behind them.",
    img: PatientManagementImg,
    link: "https://management-dasboard-demo.netlify.app/",
    category: "Full-Stack",
    tech: ["React", "Express", "node.js", "SQL", "Date Management"],
  },

  {
    id: uuidv4(),
    name: "Appointment Manager",
    desc: "Comprehensive appointment scheduling application with calendar integration and reminder system.",
    img: AppointmentImg,
    link: "https://marlos-appointment-app-demo.netlify.app/",
    category: "Web App",
    tech: ["React", "Local Storage", "Date Management"],
  },
  {
    id: uuidv4(),
    name: "Todo List App",
    desc: "Task management application with Redux state management, featuring add, edit, delete, and filter functionality.",
    img: TodoListImg,
    link: "https://marlos-todo-list-app-demo.netlify.app/",
    category: "Web App",
    tech: ["React", "Redux", "State Management"],
  },
  {
    id: uuidv4(),
    name: "Calculator App",
    desc: "Modern calculator application built with vanilla JavaScript, demonstrating clean code and DOM manipulation.",
    img: CalculatorImg,
    link: "https://marlos-calculator-app-demo.netlify.app/",
    category: "JavaScript",
    tech: ["Vanilla JS", "DOM", "CSS3"],
  },
  {
    id: uuidv4(),
    name: "Interactive Rating Component",
    desc: "Dynamic rating component with smooth animations and user feedback system built with vanilla JavaScript.",
    img: RatingComponentImg,
    link: "https://marlos-rating-component-demo.netlify.app/",
    category: "UI Component",
    tech: ["Vanilla JS", "CSS Animations"],
  },
  {
    id: uuidv4(),
    name: "Password Generator",
    desc: "Secure password generator utilizing regex patterns and customizable options for strength and complexity.",
    img: PasswordGeneratorImg,
    link: "https://marlos-password-generator-demo.netlify.app/",
    category: "UI Component",
    tech: ["Vanilla JS", "RegEx", "Security"],
  },
  {
    id: uuidv4(),
    name: "Shopify-ecom-custom-app",
    desc: "Custom Shopify e-commerce application with advanced features and integrations.",
    img: ShopifyEcomCustomAppImg,
    link: "https://shopify-ecom-custom-app.netlify.app/",
    category: "shopify-app",
    tech: [
      "React",
      "Remix",
      "Node.js",
      "Shopify API",
      "GraphQL",
      "Prisma",
      "Shopify Extensions",
    ],
  },
  {
    id: uuidv4(),
    name: "Shopify-theme-customization",
    desc: "Custom Shopify theme customization with advanced features and integrations. This project demonstrates my ability to create a unique and engaging online shopping experience for customers while also providing powerful tools for merchants to manage their stores effectively. Use this password to view the app when prompted: **yeache**",
    img: ShopifyThemeCustomizationImg,
    link: "https://rouse-commerce-lab.myshopify.com/",
    category: "shopify-app",
    tech: [
      "React",
      "Remix",
      "Node.js",
      "Shopify API",
      "GraphQL",
      "Prisma",
      "Shopify Extensions",
    ],
  },
  {
    id: uuidv4(),
    name: "Cinema Booking System",
    desc: "Full-featured cinema booking system with seat selection, ticket management, and payment integration. The Render-hosted demo may take a little time to spin up before the app appears.",
    img: CinemaBookingImg,
    link: "https://cinema-app-zedp.onrender.com/",
    category: "web-app",
    tech: ["Laravel", "PHP", "Bootstrap"],
  },
];

export const categories = [
  { id: "all", name: "All Projects" },
  { id: "full-stack", name: "Full-Stack" },
  { id: "web-app", name: "Web App" },
  { id: "ui-component", name: "UI Component" },
  { id: "javascript", name: "JavaScript" },
  { id: "shopify-app", name: "Shopify App" },
];

export default projects;
